import React, { FC } from "react";

import { useTheme } from "@emotion/react";
import { Button } from "@epignosis_llc/gnosis";
import { HamburgerSVG } from "@epignosis_llc/gnosis/icons";

import { checkColorContrast, getContrastColor } from "@styles/utils";

export type HamburgerButtonProps = {
  onClick: () => void;
  children?: never;
};

const HamburgerButton: FC<HamburgerButtonProps> = ({ onClick }) => {
  const { colors } = useTheme();

  // hamburger button exists in the top bar, so we use the topBarBackgroundColor
  const contrastedColor = getContrastColor(colors.topBarBackgroundColor.base);

  const isEnoughContrast = checkColorContrast(
    colors.topBarBackgroundColor.base,
    colors.sidebarBackgroundColor.base,
  );

  return (
    <Button
      variant="ghost"
      className="hamburger-btn"
      noGutters
      onClick={onClick}
      aria-label="Toggle sidebar"
    >
      <HamburgerSVG
        height={32}
        color={isEnoughContrast ? colors.sidebarBackgroundColor.base : contrastedColor}
      />
    </Button>
  );
};

export default HamburgerButton;
